export default __webpack_public_path__ + "static/media/automovilismo.4cee4a6a.jpg";